// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"f72af18c","206":"f6862248","319":"dbfdc34a","377":"5cd28f68","594":"1c863d6d","596":"aa43fa8d","601":"4f4160b1","724":"3d0803cc","936":"e12cf39c"}[chunkId] + ".chunk.js";
};